
import { map } from "constants/screenElements/deadDealTable";

import { formatCurrency, formatDecimalAsInteger, formatDisplayValue, formatRate, formatRateThreeDecimal, notImplemented } from "./formattersv2";

const {
  CASH_EQUITY,
  STAGE,
  LENDER,
  DEBT_MF_UNIT,
  LOAN_SPREAD,
  ALL_IN_RATE,
  TEAM_MEMBER,
  STATE,
  CITY,
  MF_UNITS,
  SQUARE_FEET,
  ASSET_CLASS,
  ASSET_TYPE,
  OCCUPANCY,
  NOI,
  NOI_ACTUAL,
  BROKER_COMPANY,
  PURCHASE_PRICE,
  APPRAISED_VALUE,
  DESIRED_LOAN_AMOUNT,
  FUND,
  STATUS,
  TARGETED_CLOSE
} = map;

export default {
  [CASH_EQUITY]: formatCurrency,
  [STAGE]: notImplemented,
  [LENDER]: formatDisplayValue,
  [DEBT_MF_UNIT]: formatCurrency,
  [LOAN_SPREAD]: formatRateThreeDecimal,
  [ALL_IN_RATE]: formatRate,
  [TEAM_MEMBER]: notImplemented,
  [STATE]: formatDisplayValue,
  [CITY]: formatDisplayValue,
  [MF_UNITS]: formatDecimalAsInteger,
  [SQUARE_FEET]: formatDecimalAsInteger,
  [ASSET_CLASS]: formatDisplayValue,
  [ASSET_TYPE]: formatDisplayValue,
  [OCCUPANCY]: formatRate,
  [NOI]: formatCurrency,
  [NOI_ACTUAL]: formatCurrency,
  [BROKER_COMPANY]: notImplemented,
  [PURCHASE_PRICE]: formatCurrency,
  [APPRAISED_VALUE]: formatCurrency,
  [DESIRED_LOAN_AMOUNT]: notImplemented,
  [FUND]: notImplemented,
  [STATUS]: notImplemented,
  [TARGETED_CLOSE]: notImplemented
};
